/**
 * Matcher de condições do CASL que compara relação por e-mail sem diferenciar
 * caixa (RDO-04, conferência de acessos).
 *
 * O compilador normaliza o lado do usuário para minúsculas (`delegacao.ts`); o
 * lado do registro vem do backend com a caixa que o Entra/Cognito gravou. Só o
 * `$in` dos campos `*.mail` (todos os caminhos de `RELACOES`) dobra a caixa —
 * qualquer outro campo (obra, status, id) segue com a igualdade exata do CASL.
 */
import { buildMongoQueryMatcher } from "@casl/ability";

interface CondicaoIn {
  field: string;
  value: unknown[];
}

interface ContextoDoMatcher {
  get: (objeto: unknown, campo: string) => unknown;
  compare: (a: unknown, b: unknown) => number;
}

const dobrar = (valor: unknown) => (typeof valor === "string" ? valor.toLowerCase() : valor);

function interpretarIn(condicao: CondicaoIn, objeto: unknown, { get, compare }: ContextoDoMatcher) {
  const valor = get(objeto, condicao.field);
  const ehEmail = condicao.field.endsWith(".mail");
  const normalizar = ehEmail ? dobrar : (x: unknown) => x;
  const candidatos = Array.isArray(valor) ? valor : [valor];

  return candidatos.some((candidato) =>
    condicao.value.some((aceito) => compare(normalizar(candidato), normalizar(aceito)) === 0),
  );
}

export const conditionsMatcherSemCaixaEmEmail = buildMongoQueryMatcher(
  {},
  { in: interpretarIn as never },
);
